export function useColor() {

    const hexToHsl = (hex) => {
        hex = hex.replace('#', '')

        // Поддержка #RGB
        if (hex.length === 3) {
            hex = hex
                .split('')
                .map(char => char + char)
                .join('')
        }

        const r = parseInt(hex.slice(0, 2), 16) / 255
        const g = parseInt(hex.slice(2, 4), 16) / 255
        const b = parseInt(hex.slice(4, 6), 16) / 255

        const max = Math.max(r, g, b)
        const min = Math.min(r, g, b)

        let h = 0
        let s = 0
        const l = (max + min) / 2

        if (max !== min) {
            const d = max - min

            s = l > 0.5
                ? d / (2 - max - min)
                : d / (max + min)

            switch (max) {
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0)
                    break

                case g:
                    h = (b - r) / d + 2
                    break

                case b:
                    h = (r - g) / d + 4
                    break
            }

            h /= 6
        }

        return {
            h: h * 360,
            s: s * 100,
            l: l * 100,
        }
    }

    const hslToHex = (h, s, l) => {
        h /= 360
        s /= 100
        l /= 100

        if (s === 0) {
            const value = Math.round(l * 255)
                .toString(16)
                .padStart(2, '0')

            return `#${value}${value}${value}`
        }

        const hueToRgb = (p, q, t) => {
            if (t < 0) t += 1
            if (t > 1) t -= 1

            if (t < 1 / 6) {
                return p + (q - p) * 6 * t
            }

            if (t < 1 / 2) {
                return q
            }

            if (t < 2 / 3) {
                return p + (q - p) * (2 / 3 - t) * 6
            }

            return p
        }

        const q = l < 0.5
            ? l * (1 + s)
            : l + s - l * s

        const p = 2 * l - q

        const r = hueToRgb(p, q, h + 1 / 3)
        const g = hueToRgb(p, q, h)
        const b = hueToRgb(p, q, h - 1 / 3)

        const toHex = value => {
            return Math.round(value * 255)
                .toString(16)
                .padStart(2, '0')
        }

        return `#${toHex(r)}${toHex(g)}${toHex(b)}`
    }

    /**
     * Делает цвет темнее.
     *
     * @param {string} color - HEX цвет
     * @param {number} amount - процент затемнения (0-100)
     * @param {string} fallbackColor - HEX дополнительного цвета
     */
    const darkenColor = (
        color,
        amount = 20,
        fallbackColor = '#000000'
    ) => {
        const hsl = hexToHsl(color)

        // Если исходный цвет практически белый,
        // затемняем fallbackColor вместо него
        if (hsl.l >= 90) {
            const fallbackHsl = hexToHsl(fallbackColor)

            fallbackHsl.l = Math.max(
                0,
                fallbackHsl.l - amount
            )

            return hslToHex(
                fallbackHsl.h,
                fallbackHsl.s,
                fallbackHsl.l
            )
        }

        // Практически чёрный
        if (hsl.l <= 10) {
            const fallbackHsl = hexToHsl(fallbackColor)

            fallbackHsl.l = Math.min(
                100,
                fallbackHsl.l + amount
            )

            return hslToHex(
                fallbackHsl.h,
                fallbackHsl.s,
                fallbackHsl.l
            )
        }

        // Обычное затемнение
        hsl.l = Math.max(0, hsl.l - amount)

        return hslToHex(hsl.h, hsl.s, hsl.l)
    }

    const lightenColor = (color, amount = 20) => {
        const hsl = hexToHsl(color)

        hsl.l = Math.min(100, hsl.l + amount)

        return hslToHex(hsl.h, hsl.s, hsl.l)
    }

    return {
        darkenColor,
        lightenColor,
        hexToHsl,
        hslToHex,
    }
}